import Joi from 'joi';

export const textToVoiceParamsSchema = Joi.object({
  text: Joi.string().required(),
});

export interface ITextToVoiceParams {
  text: string;
}
